import { Model } from 'modules/core/lib/mobx-rest'

interface IOperation {
  id: string
  operator: string
}

export class Operation extends Model<IOperation> {
  static Operators = {
    and: 'AND',
    or: 'OR',
    equals: 'EQUALS',
    not_equals: 'NOT_EQUALS',
    has_changed: 'HAS_CHANGED',
    contains: 'CONTAINS',
    greater_than: 'GREATER_THAN',
    lesser_than: 'LESSER_THAN',
  }

  static urlRoot() {
    return '/automations/operations'
  }
}
